module.exports = __webpack_public_path__ + "img/bg_image-mob.c468841.jpg";